import vehicleV1 from "./vehicle-v1.jpg";
import vehicleV2 from "./vehicle-v2.jpg";
import vehicleV3 from "./vehicle-v3.jpg";
import vehicleV4 from "./vehicle-v4.jpg";
import vehicleV5 from "./vehicle-v5.jpg";
import vehicleV6 from "./vehicle-v6.jpg";

export const demoVehicleImages: Record<string, string> = {
  v1: vehicleV1,
  v2: vehicleV2,
  v3: vehicleV3,
  v4: vehicleV4,
  v5: vehicleV5,
  v6: vehicleV6,
};
